<template>
  <div>
    <div class="head-contract table-responsive">
      <table class="table">
        <tr>
          <td align="left">
            <label>CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</label>
            <p>
              Tầng 12A, tòa nhà VTC Online, 18 Tam Trinh, phường Tương Mai, thành phố Hà Nội, Việt
              Nam
            </p>
            <p v-if="groupService === 'PAYMENT'">
              <em>Hotline:1900.63.64.88</em> |
              <em>Email:hotro@mpos.vn</em>
            </p>
            <p v-else>
              <em>Hotline:1900 63 69 56</em> |
              <em>Email:hotro@nextpay.vn</em>
            </p>
          </td>
          <td align="right">
            <span v-if="groupService === 'PAYMENT'"></span>
            <span v-else><img src="@/assets/img/nextpay-logo.svg" alt="" /></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['groupService'],
  }
</script>

<style scoped></style>
